
<template>
    <van-popup v-model="dataTipShow" round position="bottom" closeable>
         <div class="container" :style="themeCssVars">
            <div class="title-container">
                <div class="title"> {{ title }} </div>
            </div>
            <div class="item-list">
                <div v-for="(item, index) in optionList" :class="['item-container',selectIndex === index ? 'item-container-select-color' :''] " :key="index" @click="clickItem(index)">
                    <div :class="selectIndex === index ? 'item-text-selected' : 'item-text'" > {{ item }} </div>
                    <svg-icon v-if="selectIndex === index" icon-class="list_check" class-name="check-img" />
                </div>
            </div>
         </div>
     </van-popup>
   </template>
<script>
import ThemeStyle from '@/mixin/theme-style'

export default {
  name: 'CheckListPopupView',
  mixins: [ThemeStyle],
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    selectIndex: {
      type: Number,
      default: 0
    },
    optionList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      dataTipShow: this.show
    }
  },
  watch: {
    show: function(newValue, oldValue) {
      this.dataTipShow = newValue
    },
    dataTipShow: function(newValue, oldValue) {
      this.$emit('change', newValue)
    }
  },
  methods: {

    clickItem(index){
      this.$emit('onClickItem', index)
      this.dataTipShow = false
    }

  }
}
</script>
   <style lang="scss" scoped>
   .container {
       background-color: var(--popupBackground, white);
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        .title-container {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            height: 55px;
            .title {
                font-size: 16px;
                font-weight: 500;
                color: var(--textColor, #2C2C2C);
          }
        }
        .item-list {
            overflow-y: scroll;
            max-height: 400px;
            margin-bottom: 40px;
            .item-container {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                box-sizing: border-box;
                padding: 0px 28px;
                height: 64px;
                .item-text {
                    font-size: 14px;
                    font-weight: 500;
                  color: var(--textColor, #2C2C2C);
                }
                .item-text-selected {
                    font-size: 14px;
                    font-weight: 500;
                  color: var(--primaryColor, #00BBBF);
                }
                .check-img {
                    width: 24px;
                    height: 24px;
                  color: var(--primaryColor, #00BBBF);
                }
            }
            .item-container-select-color {
                background-color: var(--primaryColorAlpha, rgba(0, 187, 191, 0.1));
            }
        }

   }
   </style>
